enum UserType {
    Admin = 'admin',
    Customer = 'customer',
    Stylist = 'stylist',
    Va = 'va',
}
export default UserType;
